module.exports = __webpack_public_path__ + "img/appleicon.377276f1.377276f1.svg";